export const getAddNewResumeObj = () => {
  return {
    firstName: "",
    middleName: "",
    lastName: "",
    cv: "",
  };
};
